import Reveal from "../landing/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const MAX = 35300;

const formatEur = (n) => new Intl.NumberFormat("es-ES").format(n);

export default function Coste() {
  const { t } = useLanguage();

  return (
    <section id="coste" className="bg-cream-dark/50 py-20 md:py-28" data-testid="coste-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <p className="kicker" data-testid="coste-kicker">{t.coste.kicker}</p>
          <h2 className="mt-5 max-w-4xl font-display text-3xl font-bold leading-tight text-forest-800 md:text-4xl lg:text-5xl">
            {t.coste.title}
          </h2>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-forest-800/80">{t.coste.lead}</p>
        </Reveal>

        <Reveal className="mt-12">
          <div className="grid gap-10 md:grid-cols-2" data-testid="coste-big-numbers">
            {[t.coste.big1, t.coste.big2].map((big) => (
              <div key={big.value}>
                <p className="font-display text-4xl font-bold tracking-tight text-forest-800 md:text-5xl">{big.value}</p>
                <div className="rule mt-3 pt-3">
                  <p className="text-sm text-forest-800/70">{big.label}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="mt-14">
          <div className="space-y-7" data-testid="coste-bars">
            {t.coste.bars.map((bar) => (
              <div key={bar.name}>
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <div>
                    <p className="text-sm font-bold text-forest-800">{bar.name}</p>
                    <p className="text-xs text-forest-800/60">{bar.sub}</p>
                  </div>
                  <p className="font-mono text-sm font-bold text-forest-800">
                    {formatEur(bar.min)} – {formatEur(bar.max)} €
                  </p>
                </div>
                <div className="mt-2.5 flex h-6 w-full overflow-hidden" role="img" aria-label={`${bar.name}: ${bar.min}-${bar.max} euro`}>
                  <div className="h-full bg-forest-800/25" style={{ width: `${(bar.min / MAX) * 100}%` }} />
                  <div className="h-full bg-forest-800" style={{ width: `${((bar.max - bar.min) / MAX) * 100}%` }} />
                </div>
              </div>
            ))}
          </div>
          <div className="rule mt-6 flex flex-wrap items-center gap-x-8 gap-y-2 pt-4">
            <span className="flex items-center gap-2 text-xs text-forest-800/70">
              <span className="inline-block h-3 w-6 bg-forest-800/25" /> {t.coste.legendMin}
            </span>
            <span className="flex items-center gap-2 text-xs text-forest-800/70">
              <span className="inline-block h-3 w-6 bg-forest-800" /> {t.coste.legendMax}
            </span>
            <span className="ml-auto text-xs text-forest-800/50">{t.coste.axisNote}</span>
          </div>
        </Reveal>

        <Reveal className="mt-12">
          <div className="grid gap-8 bg-forest-800 px-8 py-8 md:grid-cols-3" data-testid="coste-strip">
            {t.coste.strip.map((stat) => (
              <div key={stat.v}>
                <p className="font-display text-3xl font-bold text-cream md:text-4xl">{stat.v}</p>
                <p className="mt-2 text-xs leading-relaxed text-cream/70">{stat.l}</p>
              </div>
            ))}
          </div>
          <p className="mt-5 max-w-4xl text-xs italic leading-relaxed text-forest-800/60" data-testid="coste-footnote">
            {t.coste.footnote}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
